module.exports = __webpack_public_path__ + "b9825cd4cdf9366335299041056db218.svg";